import {sendWsMessage} from "./socket/socket";
import {v4 as uuidv4} from "uuid";

export const getScans = async (callback) => {
    var responseId = uuidv4()
    const payload = {"action": "scans/get", "payload": "", "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}
export const getCompany = async (callback) => {
    var responseId = uuidv4()
    const payload = {"action": "company/get", "payload": "", "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}
export const getLocation = async (callback) => {
    var responseId = uuidv4()
    const payload = {"action": "locations/getLocation", "payload": "", "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}

export const getRank = async (callback) => {
    var responseId = uuidv4()
    const payload = {"action": "leaderboard/getRank", "payload": "", "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}

export const getDaily = async (callback) => {
    var responseId = uuidv4()
    const payload = {"action": "stats/getDaily", "payload": "", "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}

export const getMonthlyBaseline = async (callback) => {
    var responseId = uuidv4()
    const payload = {"action": "stats/getMonthlyBaseline", "payload": "", "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}

export const reportState = async (callback, scans) => {
    var responseId = uuidv4()
    const payload = {"action": "state/report", "payload": scans, "response": responseId}
    sendWsMessage(JSON.stringify(payload), responseId, callback)
}